<p-toast></p-toast>
<div class="flex min-h-screen flex-col bg-white text-gray-900">
  <nav class="bg-white" aria-label="Main navigation">
    <div class="flex h-16 items-center">
      <button
        pRipple
        pButton
        type="button"
        class="border-0 bg-white px-6 py-4 text-gray-700 md:px-6"
        aria-label="Open navigation menu"
        (click)="openSidebar()"
      >
        <span class="pi pi-bars" pButtonIcon></span>
      </button>
      <div class="flex grow justify-center text-center">
        <a
          class="text-lg font-semibold tracking-tight focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-blue-500"
          routerLink="/"
          aria-label="Go to homepage"
        >
          <img
            class="w-[260px] md:w-[300px]"
            alt="Luwam Trading Co. logo"
            src="/assets/logo.svg"
          />
        </a>
      </div>
      <div class="w-8"></div>
    </div>
  </nav>

  <main class="flex-1 bg-[#fff]">
    <div class="grid-wrapper">
      <div class="grid-background"></div>
      <div class="grid-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>

  <footer class="border-t border-gray-200 bg-white" aria-label="Footer">
    <div class="mx-auto max-w-screen-xl px-4 py-6 text-sm text-gray-700">
      &copy; 2025 Luwam Trading Co.
    </div>
  </footer>
</div>

@defer (hydrate on immediate) {
  <p-drawer
    position="left"
    styleClass="w-full bg-white"
    [fullScreen]="true"
    [visible]="isSidebarOpen()"
    (onHide)="closeSidebar()"
    [modal]="true"
    [blockScroll]="true"
  >
    <ng-template #headless>
      <div class="flex h-full flex-col">
        <div class="flex shrink-0 items-center justify-between px-6 pt-4">
          <img
            class="w-[260px] md:w-[300px]"
            alt="Luwam Trading Co. logo"
            src="/assets/logo.svg"
          />
          <span>
            <p-button
              type="button"
              icon="pi pi-times"
              styleClass="border-0 bg-white text-gray-700 md:px-6"
              (click)="closeSidebar()"
            ></p-button>
          </span>
        </div>
        <div class="overflow-y-auto">
          <ul class="m-0 flex list-none flex-col p-2">
            <li
              pRipple
              class="flex cursor-pointer flex-row items-center justify-between rounded-xl px-6 py-2 hover:bg-gray-100"
              routerLink="/"
              (click)="closeSidebar()"
            >
              <span class="text-xl">Home</span>
              <span class="pi pi-fw pi-caret-right"></span>
            </li>
            <li
              pRipple
              class="flex cursor-pointer flex-row items-center justify-between rounded-xl px-6 py-2 hover:bg-gray-100"
            >
              <span class="text-xl"
                >Products
                <span class="ml-2 text-sm text-gray-600"
                  >(coming soon)</span
                ></span
              >
              <span class="pi pi-fw pi-caret-right"></span>
            </li>
            <li
              pRipple
              class="flex cursor-pointer flex-row items-center justify-between rounded-xl px-6 py-2 hover:bg-gray-100"
              routerLink="/contact/reviews"
              (click)="closeSidebar()"
            >
              <span class="text-xl">Submit Review</span>
              <span class="pi pi-fw pi-caret-right"></span>
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
  </p-drawer>
}
